import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { server } from "../server";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";

function VerifyOTP() {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, signupResponse } = location.state || {};
  const [isEditingMobile, setIsEditingMobile] = useState(false);
  const [newMobile, setNewMobile] = useState("");
  const [currentMobile, setCurrentMobile] = useState(mobile);
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputsRef = useRef([]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otpDigits];
    updatedOtp[index] = value;
    setOtpDigits(updatedOtp);

    if (value && index < 3) {
      inputsRef.current[index + 1].focus();
    }

    if (updatedOtp.join("").length === 4) {
      handleSubmit(updatedOtp.join(""));
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async (passedOtp) => {
    const otp = passedOtp || otpDigits.join("");
    if (otp.length !== 4) return;

    try {
      setLoading(true);

      const response = await fetch(`${server}/auth/VerifyOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobile: Number(currentMobile),
          otp: Number(otp),
        }),
      });

      const result = await response.json();
      setLoading(false);

      if (response.ok) {
        localStorage.setItem("authToken", result.token);
        navigate("/matches", { replace: true });
      } else {
        toast.error("Invalid OTP");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Something Went Wrong");
    }
  };

  const handleChangeMobile = async () => {
    if (!newMobile || newMobile.length !== 10) {
      toast.error("Enter valid 10-digit mobile number");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${server}/auth/ChangeNumber`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          oldPhone: currentMobile.toString(),
          newPhone: newMobile.toString(),
          userObjectId: signupResponse?.userObjectId,
        }),
      });

      const result = await response.json();
      setLoading(false);

      if (response.ok) {
        toast.success("Mobile number updated");

        setCurrentMobile(newMobile);
        setOtpDigits(["", "", "", ""]);
        setNewMobile("");
        setIsEditingMobile(false);
      } else {
        toast.error(result.message || "Failed to change number");
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Header />

      <section className="py-7 gradient-section-1">
        <div className="container d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-12">
            <div className="rounded-5 p-7 bg-white text-center shadow">
              <span className="text-uppercase fw-semibold ls-md text-dark">
                Verify OTP
              </span>

              <h2 className="fw-normal ls-sm lh-1 mt-1">
                Enter OTP Sent In Mobile No.
              </h2>

              <p className="lh-sm m-0 text-secondary">
                We’ve sent a 4-digit OTP to <br />
                <span className="d-inline-flex align-items-center gap-2">
                  (+91) {currentMobile}
                  {signupResponse?.userObjectId && (
                    <i
                      className="bi bi-pencil-square text-primary cursor-pointer"
                      onClick={() => setIsEditingMobile(!isEditingMobile)}
                    ></i>
                  )}
                </span>
              </p>

              {isEditingMobile && (
                <div className="mt-3">
                  <TextField
                    className="w-lg-75 w-100 ls-sm mb-3"
                    label="New Mobile No."
                    variant="filled"
                    value={newMobile}
                    onChange={(e) => setNewMobile(e.target.value)}
                    inputProps={{ maxLength: 10 }}
                  />

                  <button
                    onClick={handleChangeMobile}
                    disabled={loading}
                    className="btn btn-outline-danger rounded-pill px-5"
                  >
                    Change Number
                  </button>
                </div>
              )}

              <div className="d-flex justify-content-center mt-4">
                <div className="d-flex gap-1">
                  {otpDigits.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputsRef.current[index] = el)}
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      maxLength={1}
                      className="otp-box text-center fs-3 rounded-3"
                      inputMode="numeric"
                    />
                  ))}
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                {loading ? (
                  <div
                    class="spinner-border text-red-primary"
                    role="status"
                  ></div>
                ) : (
                  <button
                    disabled={loading}
                    onClick={() => handleSubmit()}
                    className="btn bg-red-primary text-white fw-normal shadow fs-4 rounded-pill border-0 px-7"
                  >
                    Verify OTP
                  </button>
                )}
              </div>

              <p className="text-dark text-center mt-4 mb-0">
                Didn’t receive it?{" "}
                <span className="text-primary cursor-pointer">Resend OTP</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default VerifyOTP;
